/**
 * Le décor de « La prise parfaite » (⟦C53 · A-170 §2⟧) : de petits dessins pixel en SVG, `rect` par
 * `rect`, aucune image générée, aucun emoji posé à la place d'un dessin (⟦C48 · A-168 §3⟧ : la DA
 * de la chambre, pixel art 8-bit). Chaque forme vit sur une grille de quelques dizaines de pixels
 * (`viewBox`) et `shape-rendering: crispEdges` ne lisse jamais un bord ; les couleurs viennent
 * toutes de `tokens.css` par des classes (`.pixel-*`, `atelier.css`), jamais d'un `fill` en dur.
 */

/** Le clap : le bâton rayé en haut (il claque), l'ardoise dessous, le numéro de prise en surimpression HTML. */
export function Clap() {
  return (
    <svg className="prise-clap-svg" viewBox="0 0 36 31" aria-hidden="true" focusable="false">
      <g className="prise-clap-baton">
        <rect className="pixel-noir" x="1" y="2" width="34" height="7" />
        {Array.from({ length: 6 }, (_, i) => (
          <rect key={i} className="pixel-blanc" x={3 + i * 6} y="3" width="3" height="5" />
        ))}
        <rect className="pixel-noir" x="1" y="8" width="3" height="3" />
      </g>
      <rect className="pixel-noir" x="1" y="10" width="34" height="20" />
      <rect className="pixel-blanc" x="3" y="12" width="30" height="16" />
      {/* Les traits de l'ardoise : où l'on écrit « scène », « prise ». */}
      <rect className="pixel-noir" x="3" y="19" width="30" height="1" />
      <rect className="pixel-noir" x="19" y="12" width="1" height="7" />
    </svg>
  );
}

/** La caméra sur son pied : le corps, l'objectif, le viseur, le voyant. `voyant` s'allume pendant la prise. */
export function Camera({ voyant }: { voyant: boolean }) {
  return (
    <svg className="prise-camera-svg" viewBox="0 0 28 34" aria-hidden="true" focusable="false">
      {/* Le pied. */}
      <rect className="pixel-noir" x="13" y="20" width="2" height="9" />
      <rect className="pixel-noir" x="7" y="28" width="3" height="2" />
      <rect className="pixel-noir" x="9" y="26" width="3" height="2" />
      <rect className="pixel-noir" x="18" y="28" width="3" height="2" />
      <rect className="pixel-noir" x="16" y="26" width="3" height="2" />
      <rect className="pixel-noir" x="13" y="29" width="2" height="3" />
      {/* Le corps. */}
      <rect className="pixel-noir" x="3" y="8" width="17" height="12" />
      <rect className="pixel-corps" x="4" y="9" width="15" height="10" />
      <rect className="pixel-noir" x="5" y="5" width="7" height="4" />
      <rect className="pixel-corps" x="6" y="6" width="5" height="2" />
      {/* L'objectif. */}
      <rect className="pixel-noir" x="20" y="10" width="6" height="8" />
      <rect className="pixel-verre" x="21" y="11" width="4" height="6" />
      <rect className="pixel-blanc" x="21" y="11" width="1" height="2" />
      {/* Le voyant d'enregistrement. */}
      <rect className={voyant ? "pixel-voyant allume" : "pixel-voyant"} x="6" y="11" width="3" height="3" />
    </svg>
  );
}

/** Un projecteur de plateau : le boîtier et sa chape, qui pendent du haut de la scène. */
export function Projecteur() {
  return (
    <svg className="prise-projecteur-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      <rect className="pixel-noir" x="7" y="0" width="2" height="4" />
      <rect className="pixel-noir" x="2" y="4" width="12" height="9" />
      <rect className="pixel-corps" x="3" y="5" width="10" height="7" />
      <rect className="pixel-lumiere" x="4" y="13" width="8" height="2" />
    </svg>
  );
}
